<template>
  <div class="thank-you-box">
    <p class="thank-you-text">
      Thank You, {{ user.firstName }} {{ user.lastName }},
    </p>
    <p>
      Your quote number is
      <span class="quote-number-bold">{{
        quoteResponse.policies[0].policyNumber
      }}</span
      >.
    </p>
    <p>
      Thank you for your continued interest Porsche Auto Insurance. If you would
      like to purchase your quote, you may do so anytime online or you can call
      <a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a> to speak to a
      customer service concierge.
    </p>
    <div class="button-right-align">
      <button
        @click="continueToHomePage"
        type="button"
        class="button-primary button-primary--black -spacing-static-b"
      >
        <span class="button-primary__icon icon icon--arrow-right-hair">
          <span class="loader-base button-primary__loader"></span>
        </span>

        <span class="button-primary__label">Continue to Homepage</span>
      </button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SavedQuoteThankYou',
  props: ['quoteResponse'],
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    continueToHomePage() {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.thank-you-box {
  padding-bottom: 10px;
  .thank-you-text {
    font-size: 24px;
  }

  .alert-danger {
    color: red;
  }

  .info-box {
    margin-bottom: 1rem;
  }
  .quote-number-bold {
    font-weight: bold;
  }
}
</style>
